import styled from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "TargetPropertystyles__Container",
  componentId: "keen-query-creator__sc-1oszry6-0"
})(["&&&{position:relative;}"]);
export var TitleWrapper = styled.div.withConfig({
  displayName: "TargetPropertystyles__TitleWrapper",
  componentId: "keen-query-creator__sc-1oszry6-1"
})(["&&&{display:flex;align-items:center;}"]);
export var Subtitle = styled.div.withConfig({
  displayName: "TargetPropertystyles__Subtitle",
  componentId: "keen-query-creator__sc-1oszry6-2"
})(["&&&{font-family:'Lato Regular',sans-serif;font-size:14px;color:", ";display:flex;align-items:center;transform:translateX(0) translateY(-2px);}"], transparentize(0.5, colors.black[100]));
export var SubtitleIcon = styled.div.withConfig({
  displayName: "TargetPropertystyles__SubtitleIcon",
  componentId: "keen-query-creator__sc-1oszry6-3"
})(["&&&{transform:translateX(5px) translateY(2px);}"]);
export var PropertyOverflow = styled.div.withConfig({
  displayName: "TargetPropertystyles__PropertyOverflow",
  componentId: "keen-query-creator__sc-1oszry6-4"
})(["&&&{overflow:hidden;}"]);
export var TooltipMotionIconBold = styled.span.withConfig({
  displayName: "TargetPropertystyles__TooltipMotionIconBold",
  componentId: "keen-query-creator__sc-1oszry6-5"
})(["&&&{display:inline;font-family:'Lato Bold',sans-serif;}"]);
export var TooltipContainer = styled.div.withConfig({
  displayName: "TargetPropertystyles__TooltipContainer",
  componentId: "keen-query-creator__sc-1oszry6-6"
})(["&&&{display:inline-block;margin-left:5px;position:relative;cursor:pointer;}"]);